module.exports = __webpack_public_path__ + "img/Logo-22.5ef48dea.svg";